export type Tab = 'home' | 'household' | 'account'

export function BottomTabBar({
  active,
  onChange,
}: {
  active: Tab
  onChange: (tab: Tab) => void
}) {
  return (
    <nav className="tab-bar">
      <TabItem
        label="Talk"
        active={active === 'home'}
        onClick={() => onChange('home')}
        icon={
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z" />
          </svg>
        }
      />
      <TabItem
        label="Household"
        active={active === 'household'}
        onClick={() => onChange('household')}
        icon={
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
          </svg>
        }
      />
      <TabItem
        label="Account"
        active={active === 'account'}
        onClick={() => onChange('account')}
        icon={
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
        }
      />
    </nav>
  )
}

function TabItem({
  label,
  active,
  onClick,
  icon,
}: {
  label: string
  active: boolean
  onClick: () => void
  icon: React.ReactNode
}) {
  return (
    <button
      className={`tab-bar__item${active ? ' tab-bar__item--active' : ''}`}
      onClick={onClick}
      aria-label={label}
      aria-current={active ? 'page' : undefined}
    >
      <span className="tab-bar__icon">{icon}</span>
      <span className="tab-bar__label">{label}</span>
    </button>
  )
}
